import React from 'react'
import CaluButton from '@/components/styledComponents/CaluButton'
import CaluInput from '@/components/styledComponents/CaluInput'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Grid, Tooltip } from '@mui/material'

import s from './styles.module.scss'

const FragmentsSearchBar = ({ addNewFragment, inputSearch, setInputSearch }) => {
  return (
    <Grid container className={s.mainContainer}>
      <Grid item xs={12} md={4}>
        <CaluInput
          id="search"
          type="text"
          autoComplete="off"
          labelText="Buscar fragmento"
          value={inputSearch}
          onChange={(e) => setInputSearch(e.target.value)}
          className={s.searchBarContainer}
        />
      </Grid>

      <Grid item xs={12} md={4} className={s.containerButtonNewEntry}>
        <Tooltip
          title="Los fragmentos son bloques de texto con campos variables que te ayudarán a autocompletar los datos de cada
      paciente en las observaciones de tus fichas de historia clínica."
        >
          <HelpOutlineIcon className={s.helpButton} />
        </Tooltip>
        <CaluButton color="primary" type="add" size="large" onClick={addNewFragment}>
          Crear fragmento
        </CaluButton>
      </Grid>
    </Grid>
  )
}

export default FragmentsSearchBar
